
// @ngInject

Models.PaymentsCollection = function PaymentsCollection(BaseCollection) {

    return Class(BaseCollection, {

            constructor: function constructor(){
                this.constructor.$super.call(this);
                this._collection.__className = 'PaymentsCollection';
                this._collection.__childsType = 'PaymentModel';
                this._collection.shouldMergeOnLoad = false;
                return this._collection;
            }
        }
    );

};
